import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "upload",
  "use": "upload-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 512 512\" id=\"upload\">\n<g id=\"upload_XMLID_1_\">\n\t<path id=\"upload_XMLID_5_\" d=\"M509.2,482.2V512H2.8v-29.8H509.2z M241.1,56.8v336.1h29.8V56.8l108.9,108.9l21.4-21.4L256,0L111.7,144.3\n\t\tl21.4,21.4L241.1,56.8z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol